(() => {
  'use strict';

  // STARLESS runtime refresh: scoped product video observer 2026-08-15
  if (window.__starlessVideoFullscreenInstalled) return;
  window.__starlessVideoFullscreenInstalled = true;

  const locale = (document.documentElement.lang || 'en').toLowerCase().slice(0, 2);
  const labels = {
    en: 'View video fullscreen',
    fr: 'Afficher la vidéo en plein écran',
    de: 'Video im Vollbild anzeigen',
    es: 'Ver el vídeo en pantalla completa'
  };
  const videoLabels = {
    fr: 'Vidéo : comment utiliser la machine à espresso portable STARLESS',
    de: 'Video: Anleitung für die tragbare STARLESS Espressomaschine',
    es: 'Vídeo: cómo usar la cafetera espresso portátil STARLESS'
  };
  const localizedSources = {
    en: 'https://cdn.shopify.com/s/files/1/0938/5685/8489/files/starless-video-carrousel-universelle-1440.mp4?v=1791575137',
    fr: 'https://cdn.shopify.com/s/files/1/0938/5685/8489/files/starless-video-carrousel-universelle-1440.mp4?v=1791575137',
    de: 'https://cdn.shopify.com/s/files/1/0938/5685/8489/files/starless-video-carrousel-universelle-1440.mp4?v=1791575137',
    es: 'https://cdn.shopify.com/s/files/1/0938/5685/8489/files/starless-video-carrousel-universelle-1440.mp4?v=1791575137'
  };
  const localizedVideoPrefixes = ['Vidéo :', 'Video:', 'Vídeo:'];
  const sharedProductVideoMediaId = '70661718376825';
  const label = labels[locale] || labels.en;
  let productObserver = null;
  let observedProductRoot = null;

  const isLocalizedVideoItem = (item) => {
    if (!(item instanceof HTMLElement)) return false;
    const alt = item.dataset.alt || '';
    return localizedVideoPrefixes.some((prefix) => alt.startsWith(prefix)) ||
      (item.dataset.mediaId || '').endsWith(sharedProductVideoMediaId) ||
      (item.dataset.target || '').endsWith(sharedProductVideoMediaId);
  };

  const showFirstFrame = (video) => {
    const seek = () => {
      if (!Number.isFinite(video.duration) || video.duration <= 0.08) return;
      try {
        video.currentTime = 0.05;
      } catch (_) {}
    };

    if (video.readyState >= 1) seek();
    else video.addEventListener('loadedmetadata', seek, { once: true });
  };

  const createLocalizedVideo = (thumbnail = false) => {
    const sourceUrl = localizedSources[locale];
    if (!sourceUrl) return null;

    const video = document.createElement('video');
    video.className = thumbnail
      ? 'starless-localized-video-thumbnail'
      : 'starless-localized-inline-video';
    video.dataset.starlessLocalizedVideo = locale;
    video.preload = 'metadata';
    video.playsInline = true;
    video.setAttribute('playsinline', '');
    video.setAttribute('webkit-playsinline', '');
    video.removeAttribute('poster');

    if (thumbnail) {
      video.muted = true;
      video.defaultMuted = true;
      video.setAttribute('muted', '');
      video.setAttribute('aria-hidden', 'true');
      video.tabIndex = -1;
    } else {
      video.controls = true;
      video.setAttribute('controls', '');
      video.setAttribute('aria-label', videoLabels[locale] || label);
      video.disablePictureInPicture = true;
    }

    const source = document.createElement('source');
    source.src = sourceUrl;
    source.type = 'video/mp4';
    video.appendChild(source);
    showFirstFrame(video);
    video.load();
    return video;
  };

  const mountLocalizedSlideVideo = (item) => {
    if (!isLocalizedVideoItem(item)) return;
    if (item.dataset.starlessCoverRemoved === locale) return;

    const frame = item.querySelector('.product-media-container') || item.querySelector('.product__media') || item;
    const video = createLocalizedVideo(false);
    if (!frame || !video) return;

    frame.replaceChildren(video);
    frame.classList.add('starless-localized-video-frame');
    item.dataset.starlessCoverRemoved = locale;
  };

  const mountLocalizedThumbnailVideo = (item) => {
    if (!isLocalizedVideoItem(item)) return;
    if (item.dataset.starlessCoverRemoved === locale) return;

    const button = item.querySelector('.thumbnail');
    const video = createLocalizedVideo(true);
    if (!button || !video) return;

    button.replaceChildren(video);
    item.dataset.starlessCoverRemoved = locale;
  };

  const enterFullscreen = (video) => {
    if (typeof video.requestFullscreen === 'function') return video.requestFullscreen();
    if (typeof video.webkitEnterFullscreen === 'function') return video.webkitEnterFullscreen();
    if (typeof video.webkitRequestFullscreen === 'function') return video.webkitRequestFullscreen();

    const host = video.closest('internal-video, .product__media, .product-media-container');
    if (host && typeof host.requestFullscreen === 'function') return host.requestFullscreen();
    if (host && typeof host.webkitRequestFullscreen === 'function') return host.webkitRequestFullscreen();

    return Promise.resolve();
  };

  const setSharedVideoSource = (video) => {
    if (!(video instanceof HTMLVideoElement) || video.dataset.starlessSharedVideo === 'true') return;
    if (!video.closest('product-modal')) return;
    video.pause();
    video.removeAttribute('src');
    const source = document.createElement('source');
    source.src = localizedSources[locale] || localizedSources.en;
    source.type = 'video/mp4';
    video.replaceChildren(source);
    video.dataset.starlessSharedVideo = 'true';
    video.load();
  };

  const mountButton = (video) => {
    if (!(video instanceof HTMLVideoElement)) return;
    if (video.classList.contains('starless-localized-video-thumbnail')) return;
    if (video.dataset.starlessFullscreenReady === 'true') return;

    video.removeAttribute('poster');
    const host = video.closest('internal-video') || video.parentElement;
    if (!host) return;

    host.classList.add('starless-video-fullscreen-host');

    const button = document.createElement('button');
    button.type = 'button';
    button.className = 'starless-video-fullscreen-button';
    button.setAttribute('aria-label', label);
    button.title = label;
    button.innerHTML = `
      <svg viewBox="0 0 24 24" aria-hidden="true" focusable="false">
        <path d="M8.5 3H4a1 1 0 0 0-1 1v4.5h2V5h3.5V3Zm7 0v2H19v3.5h2V4a1 1 0 0 0-1-1h-4.5ZM5 15.5H3V20a1 1 0 0 0 1 1h4.5v-2H5v-3.5Zm16 0h-2V19h-3.5v2H20a1 1 0 0 0 1-1v-4.5Z" fill="currentColor"/>
      </svg>`;

    button.addEventListener('click', (event) => {
      event.preventDefault();
      event.stopPropagation();
      const result = enterFullscreen(video);
      if (result && typeof result.catch === 'function') result.catch(() => {});
    });

    host.appendChild(button);
    video.dataset.starlessFullscreenReady = 'true';
  };

  const install = (root = document) => {
    if (!root) return;

    if (root instanceof Element) {
      if (root.matches('.product__media-item')) mountLocalizedSlideVideo(root);
      if (root.matches('.thumbnail-list__item')) mountLocalizedThumbnailVideo(root);
      if (root.matches('product-modal video')) setSharedVideoSource(root);
      if (root.matches('media-gallery video, product-modal video')) mountButton(root);
    }

    if (!root.querySelectorAll) return;
    root.querySelectorAll('.product__media-item').forEach(mountLocalizedSlideVideo);
    root.querySelectorAll('.thumbnail-list__item').forEach(mountLocalizedThumbnailVideo);
    root.querySelectorAll('product-modal video').forEach(setSharedVideoSource);
    root.querySelectorAll('media-gallery video, product-modal video').forEach(mountButton);
  };

  const getProductRoot = () => document.querySelector('[id^="MainProduct-"]');

  const bindProductObserver = () => {
    const productRoot = getProductRoot();
    if (!productRoot || observedProductRoot === productRoot) return;

    const observedSurfaces = [
      ...productRoot.querySelectorAll('media-gallery'),
      ...document.querySelectorAll('product-modal')
    ];
    if (!observedSurfaces.length) return;

    if (productObserver) productObserver.disconnect();
    observedProductRoot = productRoot;
    productObserver = new MutationObserver((records) => {
      records.forEach((record) => {
        Array.from(record.addedNodes || []).forEach((node) => {
          if (node.nodeType === Node.ELEMENT_NODE) install(node);
        });
      });
    });
    observedSurfaces.forEach((surface) => {
      productObserver.observe(surface, { childList: true, subtree: true });
    });
  };

  const boot = () => {
    install();
    bindProductObserver();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot, { once: true });
  } else {
    boot();
  }

  if (window.Shopify && window.Shopify.designMode) {
    document.addEventListener('shopify:section:load', (event) => {
      install(event.target);
      observedProductRoot = null;
      bindProductObserver();
    });
  }
})();
